import 'css-chunksrc/client/pages/zonesPage/wbsPage/filters/dataTypeFilter/styles.scss';export default {
  "dataTypeFilter": "_dataTypeFilter_yal5q_1",
  "input": "_input_yal5q_7",
  "toggleArrow": "_toggleArrow_yal5q_23",
  "selectedDataTypes": "_selectedDataTypes_yal5q_31",
  "placeholder": "_placeholder_yal5q_40",
  "list": "_list_yal5q_45",
  "item": "_item_yal5q_57",
  "typeName": "_typeName_yal5q_70",
  "opened": "_opened_yal5q_77"
};